import api from "../../lib/api";

export default {
  namespaced: true,
  state: {
    list: [],
    loading: true,
    statusing: false,
    posting: false,
    isAddOrEdit: false,
    siteUsers: [],
    siteCategories: [],
    siteCompanies: [],
    siteGames: [],
    keys: {},
    isKeys: false,
    site: {
      id: 0,
      name: "",
      domain: "",
      logo: "",
      status: 1
    }
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_POSTING(state, payload) {
      state.posting = payload;
    },
    SET_STATUSING(state, payload) {
      state.statusing = payload;
    },
    SET_SITES(state, sites) {
      state.list = sites;
    },
    SET_IS_ADD_OR_EDIT(state, payload) {
      if (!payload)
        state.site = {
          id: 0,
          name: "",
          domain: "",
          status: 1
        };
      state.isAddOrEdit = payload;
    },
    SET_SITE(state, site) {
      state.site = site;
    },
    RESET_SITE(state) {
      state.site = {
        id: 0,
        name: "",
        url: "",
        parent_id: 0,
        logo: "",
        status: 1
      };
    },
    SET_SITE_USERS(state, users) {
      state.siteUsers = users;
    },
    SET_SITE_GAMES(state, games) {
      state.siteGames = games;
    },
    SET_SITE_CATEGORIES(state, categories) {
      state.siteCategories = categories;
    },
    SET_SITE_COMPANIES(state, companies) {
      state.siteCompanies = companies;
    },
    SET_KEYS(state, keys) {
      state.keys = keys;
    },
    SET_IS_KEYS(state, payload) {
      if (!payload) state.keys = {};
      state.isKeys = payload;
    },
    RESET_KEYS(state) {
      state.keys = {};
    }
  },
  actions: {
    resetKeys({ commit }) {
      commit("RESET_KEYS");
    },
    setIsKeys({ commit }, payload) {
      commit("SET_IS_KEYS", payload);
    },
    async getAllSiteAlts({ dispatch }) {
      await dispatch("getSiteCategories", { site_id: 1 });
    },
    // maybe new module? (siteGames)
    async getSiteGames({ commit }, { site_id }) {
      const response = await api.get(`/sites/${site_id}/owned_games`);
      commit("SET_SITE_GAMES", response.data);
    },
    async addGame({ dispatch }, { siteId, gameId }) {
      await api.post(`/sites/${siteId}/owned_games`, {
        game_id: gameId
      });
      await dispatch("getSiteGames", { site_id: siteId });
      // await dispatch("getSiteCategories", { site_id: siteId });
      // await dispatch("getSiteCompanies", { site_id: siteId });
    },
    async addGameBatch({ dispatch }, { siteId, gameIds }) {
      await api.post(`/sites/${siteId}/owned_games/batch`, {
        owned_game: {
          game_ids: gameIds
        }
      });
      await dispatch("getSiteGames", { site_id: siteId });
    },
    async removeGame({ dispatch }, { site_id, game_id }) {
      await api.delete(`/sites/${site_id}/owned_games/${game_id}`);
      await dispatch("getSiteGames", { site_id });
      // await dispatch("getSiteCategories", { site_id });
      // await dispatch("getSiteCompanies", { site_id });
    },
    async removeGameBatch({ dispatch }, { site_id, game_ids }) {
      await api.delete(`/sites/${site_id}/owned_games/batch`, {
        data: {
          owned_game: {
            game_ids
          }
        }
      });
      await dispatch("getSiteGames", { site_id });
    },
    async toggleSiteGameStatus({ dispatch }, { site_id, game_id, status }) {
      await api.put(`/sites/${site_id}/owned_games/${game_id}`, {
        owned_game: {
          status
        }
      });
      dispatch("getSiteGames", { site_id });
    },
    // /maybe new module? (siteGames)
    // maybe new module? (siteCompanies)
    async getSiteCompanies({ commit }, { site_id }) {
      const response = await api.get(`/sites/${site_id}/companies`);
      commit("SET_SITE_COMPANIES", response.data);
    },
    async addCompany({ dispatch }, { siteId, companyId }) {
      await api.post(`/sites/${siteId}/companies/${companyId}`);
      await dispatch("getSiteGames", { site_id: siteId });
      await dispatch("getSiteCategories", { site_id: siteId });
      await dispatch("getSiteCompanies", { site_id: siteId });
    },
    async removeCompany({ dispatch }, { siteId, companyId }) {
      await api.delete(`/sites/${siteId}/companies/${companyId}`);
      await dispatch("getSiteGames", { site_id: siteId });
      await dispatch("getSiteCategories", { site_id: siteId });
      await dispatch("getSiteCompanies", { site_id: siteId });
    },
    // /maybe new module? (siteCompanies)
    // maybe new module? (siteCategories)
    async getSiteCategories({ commit }, { site_id }) {
      const response = await api.get(`/sites/${site_id}/categories`);
      commit("SET_SITE_CATEGORIES", response.data);
    },
    async addCategory({ dispatch }, { siteId, categoryId }) {
      await api.post(`/sites/${siteId}/categories/${categoryId}`);
      await dispatch("getSiteGames", { site_id: siteId });
      await dispatch("getSiteCategories", { site_id: siteId });
      await dispatch("getSiteCompanies", { site_id: siteId });
    },
    async removeCategory({ dispatch }, { siteId, categoryId }) {
      await api.delete(`/sites/${siteId}/categories/${categoryId}`);
      await dispatch("getSiteGames", { site_id: siteId });
      await dispatch("getSiteCategories", { site_id: siteId });
      await dispatch("getSiteCompanies", { site_id: siteId });
    },
    // /maybe new module? (siteCategories)
    async getKeys({ commit }, site_id) {
      const response = await api.get(`/sites/${site_id}/keys`);
      commit("SET_KEYS", response.data);
      commit("SET_IS_KEYS", true);
    },
    async addSiteUser({ dispatch }, { site_id, user_id }) {
      await api.post(`/sites/${site_id}/users`, {
        site_user: {
          user_id
        }
      });
      await dispatch("getSiteUsers", { site_id });
    },
    async removeSiteUser({ dispatch }, { site_id, user_id }) {
      await api.delete(`/sites/${site_id}/users/${user_id}`);
      await dispatch("getSiteUsers", { site_id });
    },
    async getSiteUsers({ commit }, { site_id }) {
      const response = await api.get(`/sites/${site_id}/users`);
      commit("SET_SITE_USERS", response.data);
    },
    async getSiteAndUsers({ commit, dispatch }, { id, bypass = false } = {}) {
      commit("SET_POSTING", true);
      if (!bypass) commit("SET_LOADING", true);
      commit("SET_SITE", await dispatch("getSiteById", id));
      const response = await api.get(`/sites/${id}/users`);
      commit("SET_SITE_USERS", response.data);
      commit("SET_POSTING", false);
      if (!bypass) commit("SET_LOADING", false);
    },
    setLoading({ commit }, payload) {
      commit("SET_LOADING", payload);
    },
    setIsAddOrEdit({ commit }, payload) {
      commit("SET_IS_ADD_OR_EDIT", payload);
    },
    resetSite({ commit }) {
      commit("RESET_SITE");
    },
    async getSite({ commit, dispatch }, id) {
      commit("SET_LOADING", true);
      commit("SET_SITE", await dispatch("getSiteById", id));
      commit("SET_LOADING", false);
    },
    async getSiteById({}, id) {
      const response = await api.get(`/sites/${id}`);
      return response.data;
    },
    async getSites({ commit }, { bypass = false } = {}) {
      if (!bypass) commit("SET_LOADING", true);
      const response = await api.get("/sites");
      // response.data.sort((a, b) => a.order - b.order);
      commit("SET_SITES", response.data);
      if (!bypass) commit("SET_LOADING", false);
    },
    async editSite({ dispatch, commit }, id) {
      commit("SET_SITE", await dispatch("getSiteById", id));
      commit("SET_IS_ADD_OR_EDIT", true);
    },
    async toggleStatus({ dispatch, commit }, site) {
      commit("SET_STATUSING", true);
      await api.patch(`/sites/${site.id}`, {
        status: !site.status
      });
      await dispatch("getSites", { bypass: true });
      commit("SET_STATUSING", false);
    },
    async saveSite({ commit, dispatch }, site) {
      commit("SET_POSTING", true);
      try {
        if (site.id === 0) {
          let data = await api.post(
            "/sites",
            { site },
            {
              headers: {
                "Content-Type": site.logo
                  ? "multipart/form-data"
                  : "application/json"
              }
            }
          );
          let keys = {
            private_key: data.data.private_key,
            public_key: data.data.public_key
          };
          console.log("keys:::", keys);
          commit("SET_KEYS", keys);
          commit("SET_IS_KEYS", true);
        } else {
          await api.put(
            `/sites/${site.id}`,
            { site },
            {
              headers: {
                "Content-Type": site.logo
                  ? "multipart/form-data"
                  : "application/json"
              }
            }
          );
        }
        await dispatch("getSites");
        commit("SET_POSTING", false);
        commit("SET_IS_ADD_OR_EDIT", false);
        commit("RESET_SITE");
      } catch (error) {
        commit("SET_POSTING", false);
      }
    },
    async deleteSite({ dispatch }, id) {
      await api.delete(`/sites/${id}`);
      await dispatch("getSites");
    }
  },
  getters: {
    sites: state => state.list,
    site: state => state.site,
    siteUsers: state => state.siteUsers,
    loading: state => state.loading,
    posting: state => state.posting,
    statusing: state => state.statusing,
    isAddOrEdit: state => state.isAddOrEdit,
    siteCategories: state => state.siteCategories,
    siteCompanies: state => state.siteCompanies,
    siteGames: state => state.siteGames,
    keys: state => state.keys,
    isKeys: state => state.isKeys
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/site.js